export const translations = {
  en: {
    // Navigation
    nav: {
      flavors: "Our Gelato",
      story: "Our Story",
      visit: "Visit Us",
    },
    // Hero
    hero: {
      title: "Mary Gelateria",
      subtitle: "Artisanal Italian Gelato in Le Marais, Paris",
      tagline: "100% natural. Fresh every morning.",
      cta: "Discover Our Shop",
      award: "Winner - Cono Prize 34th Edition",
    },
    // Flavors Section
    flavors: {
      sectionTitle: "Our Artisanal Gelato",
      sectionSubtitle: "Best Ice Cream in Le Marais",
      newFlavors: "New flavors every week",
      pureIngredients: "Only milk, cream & fresh fruits",
      noAdditives: "No preservatives, no colorants, no additives",
    },
    // Story Section
    story: {
      sectionTitle: "Exceptional Natural Gelato",
      subtitle: "The Art of Italian Gelato in Paris",
      paragraph1: "Mary Gelateria produces exceptional natural artisanal gelato containing only milk, cream, and fresh fruits. Of course, no preservatives or colorants are added.",
      paragraph2: "Our gelato is made exclusively with premium natural ingredients. The fruits are carefully selected by Mary during her daily morning visit to the market. They are then cut and pressed to extract the pulp and juice.",
      paragraph3: "The result is simply stunning. In fifteen years of existence, we have received zero negative feedback in person or on social media, despite the abundance of comments about our shop (over 150 reviews).",
      highlight: "15",
      highlightText: "years of passion & excellence",
    },
    // Location Section
    location: {
      sectionTitle: "Visit Our Ice Cream Shop in Le Marais",
      subtitle: "Find Us in the Heart of Paris",
      address: "60, rue du Temple",
      city: "75003 Paris",
      phone: "01.73.74.88.22",
      email: "mary.gelateria@gmail.com",
      hours: "Opening Hours",
      schedule: {
        weekdays: "Tuesday - Sunday: 12h - 19h30",
        closed: "Monday: Closed",
      },
      reviews: "See our reviews on TripAdvisor",
    },
    // CTA Section
    cta: {
      title: "Taste the Difference",
      subtitle: "Visit Mary Gelateria Today",
      description: "Experience the best artisanal gelato in Le Marais, Paris. Made fresh daily with 100% natural ingredients.",
      button: "Get Directions",
    },
    // Footer
    footer: {
      tagline: "Artisanal Italian Gelato",
      location: "Le Marais, Paris",
      copyright: "© 2024 Mary Gelateria. All rights reserved.",
    },
    // Neighborhood Section
    neighborhood: {
      sectionTitle: "In the Heart of Le Marais",
      subtitle: "A Legendary Neighborhood",
      description: "Nestled in one of Paris's most vibrant and historic neighborhoods, Mary Gelateria is the perfect stop during your stroll through the charming streets of Le Marais. Between boutiques, galleries, and cafés, treat yourself to a moment of pure Italian indulgence.",
      feature1: "Historic Quarter",
      feature2: "Art Galleries",
      feature3: "Charming Cafés",
    },
  },
  fr: {
    // Navigation
    nav: {
      flavors: "Nos Glaces",
      story: "Notre Histoire",
      visit: "Nous Trouver",
    },
    // Hero
    hero: {
      title: "Mary Gelateria",
      subtitle: "Glaces Artisanales Italiennes dans le Marais, Paris",
      tagline: "100% naturel. Frais chaque matin.",
      cta: "Découvrir Notre Boutique",
      award: "Lauréate - Prix Cono 34ème Édition",
    },
    // Flavors Section
    flavors: {
      sectionTitle: "Nos Glaces Artisanales",
      sectionSubtitle: "Les Meilleures Glaces du Marais",
      newFlavors: "Nouveaux parfums chaque semaine",
      pureIngredients: "Que du lait, de la crème et des fruits frais",
      noAdditives: "Sans conservateur, sans colorant, sans additifs",
    },
    // Story Section
    story: {
      sectionTitle: "Des Glaces Naturelles d'Exception",
      subtitle: "L'Art de la Glace Italienne à Paris",
      paragraph1: "Mary Gelateria produit des glaces artisanales naturelles d'exception qui ne contiennent que du lait, de la crème et des fruits frais. N'est ajouté bien entendu aucun conservateur ni colorant.",
      paragraph2: "Nos glaces ne sont faites qu'avec des matières naturelles de première qualité. Les fruits sont soigneusement choisis par Mary lors de sa visite quotidienne au marché chaque matin. Ils sont ensuite découpés et pressés afin d'en extraire la pulpe et le jus.",
      paragraph3: "Le résultat est tout simplement stupéfiant. En quinze années d'existence, nous n'avons eu aucun retour négatif en face à face ou sur les réseaux sociaux, et ce malgré l'abondance de commentaires sur notre boutique (plus de 150 commentaires déposés).",
      highlight: "15",
      highlightText: "ans de passion & d'excellence",
    },
    // Location Section
    location: {
      sectionTitle: "Visitez Notre Glacier dans le Marais",
      subtitle: "Retrouvez-nous au Cœur de Paris",
      address: "60, rue du Temple",
      city: "75003 Paris",
      phone: "01.73.74.88.22",
      email: "mary.gelateria@gmail.com",
      hours: "Horaires d'Ouverture",
      schedule: {
        weekdays: "Mardi - Dimanche : 12h - 19h30",
        closed: "Lundi : Fermé",
      },
      reviews: "Voir nos avis sur TripAdvisor",
    },
    // CTA Section
    cta: {
      title: "Goûtez la Différence",
      subtitle: "Visitez Mary Gelateria Aujourd'hui",
      description: "Découvrez les meilleures glaces artisanales du Marais, Paris. Préparées fraîches chaque jour avec 100% d'ingrédients naturels.",
      button: "Itinéraire",
    },
    // Footer
    footer: {
      tagline: "Glaces Artisanales Italiennes",
      location: "Le Marais, Paris",
      copyright: "© 2024 Mary Gelateria. Tous droits réservés.",
    },
    // Neighborhood Section
    neighborhood: {
      sectionTitle: "Au Cœur du Marais",
      subtitle: "Un Quartier Légendaire",
      description: "Nichée dans l'un des quartiers les plus vibrants et historiques de Paris, Mary Gelateria est l'arrêt parfait lors de votre promenade dans les rues charmantes du Marais. Entre boutiques, galeries et cafés, offrez-vous un moment de pure gourmandise italienne.",
      feature1: "Quartier Historique",
      feature2: "Galeries d'Art",
      feature3: "Cafés de Charme",
    },
  },
  it: {
    // Navigation
    nav: {
      flavors: "I Nostri Gelati",
      story: "La Nostra Storia",
      visit: "Dove Siamo",
    },
    // Hero
    hero: {
      title: "Mary Gelateria",
      subtitle: "Gelato Artigianale Italiano nel Marais, Parigi",
      tagline: "100% naturale. Fresco ogni mattina.",
      cta: "Scopri la Nostra Bottega",
      award: "Vincitrice - Premio Cono 34ª Edizione",
    },
    // Flavors Section
    flavors: {
      sectionTitle: "Il Nostro Gelato Artigianale",
      sectionSubtitle: "Il Miglior Gelato del Marais",
      newFlavors: "Nuovi gusti ogni settimana",
      pureIngredients: "Solo latte, panna e frutta fresca",
      noAdditives: "Senza conservanti, senza coloranti, senza additivi",
    },
    // Story Section
    story: {
      sectionTitle: "Gelato Naturale d'Eccezione",
      subtitle: "L'Arte del Gelato Italiano a Parigi",
      paragraph1: "Mary Gelateria produce gelati artigianali naturali d'eccezione che contengono solo latte, panna e frutta fresca. Naturalmente, non vengono aggiunti conservanti né coloranti.",
      paragraph2: "I nostri gelati sono fatti esclusivamente con materie prime naturali di prima qualità. La frutta viene scelta con cura da Mary durante la sua visita quotidiana al mercato ogni mattina. Viene poi tagliata e spremuta per estrarne la polpa e il succo.",
      paragraph3: "Il risultato è semplicemente stupefacente. In quindici anni di attività, non abbiamo mai ricevuto un feedback negativo di persona o sui social media, nonostante l'abbondanza di commenti sul nostro negozio (oltre 150 recensioni).",
      highlight: "15",
      highlightText: "anni di passione ed eccellenza",
    },
    // Location Section
    location: {
      sectionTitle: "Visita la Nostra Gelateria nel Marais",
      subtitle: "Trovaci nel Cuore di Parigi",
      address: "60, rue du Temple",
      city: "75003 Parigi",
      phone: "01.73.74.88.22",
      email: "mary.gelateria@gmail.com",
      hours: "Orari di Apertura",
      schedule: {
        weekdays: "Martedì - Domenica: 12h - 19h30",
        closed: "Lunedì: Chiuso",
      },
      reviews: "Vedi le nostre recensioni su TripAdvisor",
    },
    // CTA Section
    cta: {
      title: "Assaggia la Differenza",
      subtitle: "Visita Mary Gelateria Oggi",
      description: "Scopri il miglior gelato artigianale del Marais, Parigi. Preparato fresco ogni giorno con ingredienti 100% naturali.",
      button: "Indicazioni",
    },
    // Footer
    footer: {
      tagline: "Gelato Artigianale Italiano",
      location: "Le Marais, Parigi",
      copyright: "© 2024 Mary Gelateria. Tutti i diritti riservati.",
    },
    // Neighborhood Section
    neighborhood: {
      sectionTitle: "Nel Cuore del Marais",
      subtitle: "Un Quartiere Leggendario",
      description: "Situata in uno dei quartieri più vivaci e storici di Parigi, Mary Gelateria è la tappa perfetta durante la vostra passeggiata per le affascinanti strade del Marais. Tra boutique, gallerie e caffè, concedetevi un momento di pura delizia italiana.",
      feature1: "Quartiere Storico",
      feature2: "Gallerie d'Arte",
      feature3: "Caffè Caratteristici",
    },
  },
};

export const getTranslation = (lang, path) => {
  const keys = path.split('.');
  let result = translations[lang];
  for (const key of keys) {
    result = result?.[key];
  }
  return result || path;
};
